/**
 * Diamond (Hexagon) Cushion Configurator — UNIVERSAL-BLOCK version
 * uscushion.com · 2026-08
 *
 * Runs INSIDE cushion-configurator-block.liquid (formula_type == 'diamond').
 * Same integration pattern as cushion-configurator-baywindow.js.
 *
 * Symmetric 6-sided "diamond" pattern. Inputs (inches) → shared slots:
 *   TE = top edge width       -> #cc-dim-l
 *   MW = max width (middle)    -> #cc-dim-w
 *   T  = thickness             -> #cc-dim-t
 *   BE = bottom edge width     -> #cc-back-l
 *   TH = top height            -> #cc-back-w
 *   BH = bottom height         -> #cc-back-t
 *   Derived: upper/lower diagonal edges. Zipper = the two upper diagonals (green).
 *   Material on bounding box, shipping weight on true polygon area.
 */
(function () {
  'use strict';

  var FABRIC_PRICE_RMB = 25;
  var FABRIC_RATE_RMB  = { marine: 54 };
  function fabricRate() {
    var g = (state.fabric && state.fabric.tags) ? extractTag(state.fabric.tags, 'grade') : '';
    return FABRIC_RATE_RMB[g] || FABRIC_PRICE_RMB;
  }
  var FOAM_PRICE_RMB = 1750, FOAM_DENSITY = 35, FABRIC_GSM = 400, SHIPPING_RMB = 90,
      ACCESSORIES_RMB = 30, EXCHANGE_RATE = 6.8, PAYMENT_FEE_RATE = 0.049,
      TARGET_COST_RATIO = 0.40, MARINE_COST_RATIO = 0.38, COVER_COST_RATIO = 0.55, MIN_PRICE = 45;
  function targetRatio() {
    var g = (state.fabric && state.fabric.tags) ? extractTag(state.fabric.tags, 'grade') : '';
    return g === 'marine' ? MARINE_COST_RATIO : TARGET_COST_RATIO;
  }

  var ADDON = {
    piping:      { none: 0, single: 5, double: 8 },
    pipingColor: { match: 0, white: 5, black: 5, navy: 5, cream: 5 },
    straps:      { none: 0, two: 2, four: 4 },
    zipper:      { regular: 0, invisible: 0 },
    antislip:    { none: 0, black_pad: 5, beige_pad: 5, velcro: 9 },
    throwPillow: {
      none: 0, '2pcs_12x20': 29, '2pcs_16x16': 29, '2pcs_18x18': 32, '2pcs_20x20': 35,
      '2pcs_24x24': 38, '2pcs_custom': 40, '4pcs_12x20': 51, '4pcs_16x16': 51, '4pcs_18x18': 57,
      '4pcs_20x20': 63, '4pcs_24x24': 67, '4pcs_custom': 70
    },
    pillowCovers: {
      none: 0, '2pcs_12x20': 19, '2pcs_16x16': 19, '2pcs_18x18': 21, '2pcs_20x20': 24,
      '2pcs_24x24': 29, '2pcs_custom': 31, '4pcs_12x20': 32, '4pcs_16x16': 32, '4pcs_18x18': 36,
      '4pcs_20x20': 42, '4pcs_24x24': 52, '4pcs_custom': 55
    },
    armrestPillow: { none: 0, square_2pcs: 30, round_2pcs: 30 }
  };
  var PILLOW_DIMS = {
    none: { l: 0, w: 0, q: 0 },
    '2pcs_12x20': { l: 12, w: 20, q: 2 }, '2pcs_16x16': { l: 16, w: 16, q: 2 },
    '2pcs_18x18': { l: 18, w: 18, q: 2 }, '2pcs_20x20': { l: 20, w: 20, q: 2 },
    '2pcs_24x24': { l: 24, w: 24, q: 2 }, '2pcs_custom': { l: 20, w: 20, q: 2 },
    '4pcs_12x20': { l: 12, w: 20, q: 4 }, '4pcs_16x16': { l: 16, w: 16, q: 4 },
    '4pcs_18x18': { l: 18, w: 18, q: 4 }, '4pcs_20x20': { l: 20, w: 20, q: 4 },
    '4pcs_24x24': { l: 24, w: 24, q: 4 }, '4pcs_custom': { l: 20, w: 20, q: 4 }
  };
  var LABELS = {
    none: 'None', single: 'Single piping', double: 'Double piping',
    match: 'Match fabric', white: 'White piping', black: 'Black piping', navy: 'Navy piping', cream: 'Cream piping',
    two: '2 straps', four: '4 straps', regular: 'Regular zipper', invisible: 'Invisible zipper',
    velcro: 'Velcro', black_pad: 'Black pad', beige_pad: 'Beige pad'
  };
  var FABRIC_COLORS = {
    'blue':'#2c3e6b','navy':'#1a2540','teal':'#2a7a6b','green':'#4a7a2a','sage':'#a8b89a','red':'#b83232',
    'coral':'#d85a45','orange':'#d4783a','yellow':'#d4a83a','gold':'#c8963a','pink':'#d4649a','purple':'#6a4a9a',
    'lavender':'#9a8ab8','brown':'#7a5a3a','camel':'#c8a878','tan':'#c8b08a','beige':'#d4c8a8','cream':'#ede8df',
    'ivory':'#f0ead8','white':'#f5f5f0','gray':'#9a9a9a','grey':'#9a9a9a','charcoal':'#4a4a4a','black':'#1a1a1a',
    'mint':'#98d4b4','rust':'#b7502a','mustard':'#c8a020','olive':'#6b702a','blush':'#de9898','mauve':'#b07898',
    'burgundy':'#6b1a2a','taupe':'#8a7a6a','sand':'#c8b898','silver':'#bfc0c2','steel blue':'#4a7a98',
    'dark olive':'#4a4a2a','dark green':'#2a5a2a','dark brown':'#4a3020','dark blue':'#1a2a5a','dark teal':'#1a5a5a',
    'dark gray':'#5a5a5a','light gray':'#c8c8c8','gray blue':'#6a7a8a','yellow green':'#8ab82a','gray black':'#3a3a3a'
  };

  var DEF = { te: 45, mw: 70, be: 10, th: 15, bh: 31, t: 3 };

  var state = {
    te: 0, mw: 0, be: 0, th: 0, bh: 0, t: 0,
    fabric: null, piping: '', pipingColor: 'match', straps: '',
    zipper: 'regular', zipperPlacement: '', antislip: '',
    extraCovers: '0', throwPillow: 'none', pillowCovers: 'none', armrestPillow: 'none', notes: ''
  };
  var els = {};

  function hexToRgb(hex){hex=hex.replace('#','');return [parseInt(hex.substr(0,2),16),parseInt(hex.substr(2,2),16),parseInt(hex.substr(4,2),16)];}
  function rgbToHex(r,g,b){return '#'+[r,g,b].map(function(c){var x=Math.round(Math.max(0,Math.min(255,c))).toString(16);return x.length===1?'0'+x:x;}).join('');}
  function lighten(hex,r){var c=hexToRgb(hex);return rgbToHex(c[0]+(255-c[0])*r,c[1]+(255-c[1])*r,c[2]+(255-c[2])*r);}
  function darken(hex,r){var c=hexToRgb(hex);return rgbToHex(c[0]*(1-r),c[1]*(1-r),c[2]*(1-r));}
  function extractTag(tags,prefix){if(!tags)return '';for(var i=0;i<tags.length;i++){var t=(typeof tags[i]==='string'?tags[i]:'').toLowerCase().trim();if(t.indexOf(prefix+':')===0)return tags[i].split(':')[1].trim().toLowerCase();}return '';}

  /* ─── Geometry ─── */
  function vertices(te, mw, be, th, bh) {
    return [ [-te/2,0],[te/2,0],[mw/2,th],[be/2,th+bh],[-be/2,th+bh],[-mw/2,th] ];
  }
  function polygonAreaIn2(v){var a=0;for(var i=0;i<v.length;i++){var j=(i+1)%v.length;a+=v[i][0]*v[j][1]-v[j][0]*v[i][1];}return Math.abs(a)/2;}
  function perimeterIn(v){var p=0;for(var i=0;i<v.length;i++){var j=(i+1)%v.length;p+=Math.hypot(v[j][0]-v[i][0],v[j][1]-v[i][1]);}return p;}
  function upperDiag(te,mw,th){return Math.hypot((mw-te)/2,th);}
  function lowerDiag(be,mw,bh){return Math.hypot((mw-be)/2,bh);}
  function bboxAreaIn2(v){var xs=v.map(function(p){return p[0];}),ys=v.map(function(p){return p[1];});return (Math.max.apply(null,xs)-Math.min.apply(null,xs))*(Math.max.apply(null,ys)-Math.min.apply(null,ys));}

  function calcBasePrice(v,T,ec,pk){
    if(!v||!T)return null;var IN=39.37;
    var actualAreaM2=polygonAreaIn2(v)/(IN*IN);
    var matAreaM2=bboxAreaIn2(v)/(IN*IN);
    var perimM=perimeterIn(v)/IN;var Tm=T/IN;
    var fabricAreaMat=matAreaM2*2+perimM*Tm;var foamVolMat=matAreaM2*Tm;
    var totalWeight=foamVolMat*FOAM_DENSITY+fabricAreaMat*FABRIC_GSM/1000;
    if(pk&&pk!=='none'){var p=PILLOW_DIMS[pk];if(p)totalWeight+=(p.l/IN)*(p.w/IN)*2*FABRIC_GSM/1000*p.q;}
    var totalRMB=fabricAreaMat*fabricRate()+foamVolMat*FOAM_PRICE_RMB+totalWeight*SHIPPING_RMB+ACCESSORIES_RMB;
    var base=totalRMB/EXCHANGE_RATE/(1-PAYMENT_FEE_RATE)/targetRatio();
    return Math.max(base*(window.__CC_COVER_FACTOR||1),MIN_PRICE);
  }

  /* One extra cover = a fabric-only shell (no foam). Mirrors calcBasePrice's fabric
     basis: MATERIAL uses the bounding rect (bbox), shipping weight uses the finished
     (actual) area. Fabric grade auto via fabricRate, at COVER_COST_RATIO (45%). */
  function extraCoverUnit(){
    if(!dimsValid())return 0;
    var IN=39.37;
    var v=vertices(state.te,state.mw,state.be,state.th,state.bh);
    var actualAreaM2=polygonAreaIn2(v)/(IN*IN);
    var matAreaM2=bboxAreaIn2(v)/(IN*IN);
    var perimM=perimeterIn(v)/IN,Tm=state.t/IN;
    var matFabric=matAreaM2*2+perimM*Tm;                        // material: bounding rect
    var shipWeight=(actualAreaM2*2+perimM*Tm)*FABRIC_GSM/1000;  // ship: finished cover
    var totalRMB=matFabric*fabricRate()+shipWeight*SHIPPING_RMB+ACCESSORIES_RMB;
    return Math.round(totalRMB/EXCHANGE_RATE/(1-PAYMENT_FEE_RATE)/COVER_COST_RATIO);
  }
  function updateExtraCoverLabels(){
    if(!els.extraCovers)return;
    var unit=extraCoverUnit(),opts=els.extraCovers.options;
    for(var i=0;i<opts.length;i++){
      var n=parseInt(opts[i].value)||0;
      if(n===0){opts[i].text='No extra cover';continue;}
      var label=(n===1?'1 set':n+' sets');
      opts[i].text=unit>0?label+' (+$'+(unit*n)+')':label;
    }
  }
  function getAddonTotal(){
    return (ADDON.piping[state.piping]||0)+(ADDON.pipingColor[state.pipingColor]||0)
      +(ADDON.straps[state.straps]||0)+(ADDON.zipper[state.zipper]||0)+(ADDON.antislip[state.antislip]||0)
      +extraCoverUnit()*(parseInt(state.extraCovers)||0)+(ADDON.throwPillow[state.throwPillow]||0)
      +(ADDON.pillowCovers[state.pillowCovers]||0)+(ADDON.armrestPillow[state.armrestPillow]||0);
  }
  function dimsValid(){return state.te>=4&&state.mw>=state.te&&state.mw>=state.be&&state.be>=2&&state.th>=2&&state.bh>=2&&state.t>=1;}
  function isComplete(){return dimsValid()&&state.fabric&&state.piping&&state.straps&&state.antislip;}

  /* ═══ SVG preview ═══ */
  function drawCushion(){
    var svg=els.dimSvg;if(!svg)return;
    var VB_W=420,VB_H=230;svg.setAttribute('viewBox','0 0 '+VB_W+' '+VB_H);
    var h='';

    var narrow=window.matchMedia&&window.matchMedia('(max-width: 749px)').matches;
    svg.style.maxHeight=narrow?'200px':'240px';
    var TODO='#C0612B';
    function f(n){return n.toFixed(1);}
    function s(a){return a[0].toFixed(1)+','+a[1].toFixed(1);}
    function tag(letter,val){return val?letter+' '+val+'″':letter+' = ?';}
    function col(val,base){return val?base:TODO;}
    function lbl(x,y,txt,color,anchor,size){h+='<text x="'+f(x)+'" y="'+f(y)+'" text-anchor="'+(anchor||'middle')+'" font-size="'+(size||15)+'" font-family="Poppins,sans-serif" font-weight="600" fill="'+color+'">'+txt+'</text>';}
    function arrowLine(a,b,color){h+='<line x1="'+f(a[0])+'" y1="'+f(a[1])+'" x2="'+f(b[0])+'" y2="'+f(b[1])+'" stroke="'+color+'" stroke-width="1.1" marker-start="url(#dc-arr)" marker-end="url(#dc-arr)"/>';}
    function fabricColors(){var fc='#EDE9E0',sc2='#2A2A28';if(state.fabric&&state.fabric.tags){var ct=extractTag(state.fabric.tags,'color');var bx=FABRIC_COLORS[ct];if(bx){fc=lighten(bx,0.45);sc2=darken(bx,0.45);var rgb=hexToRgb(sc2);if((rgb[0]+rgb[1]+rgb[2])/3>150)sc2='#2A2A28';}}return [fc,sc2];}

    var empty=!(state.te||state.mw||state.be||state.th||state.bh);
    var te=state.te||DEF.te, mw=state.mw||DEF.mw, be=state.be||DEF.be, th=state.th||DEF.th, bh=state.bh||DEF.bh;
    if(mw<te)mw=te; if(mw<be)mw=be;
    var v=vertices(te,mw,be,th,bh);
    var padL=74,padR=84,padT=38,padB=36;
    var shapeW=mw,shapeH=th+bh;var availW=VB_W-padL-padR,availH=VB_H-padT-padB;
    var scale=Math.min(availW/shapeW,availH/shapeH);var offX=padL+availW/2,offY=padT+(availH-shapeH*scale)/2;
    function P(pt){return [offX+pt[0]*scale,offY+pt[1]*scale];}
    var sp=v.map(P);
    var fcs=fabricColors(),fillC=fcs[0],strokeC=fcs[1];
    var GREEN='#5a9e2a',BLUE='#2f8fd4',DIMC='#1a4f78';
    h+='<defs><marker id="dc-arr" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="5" markerHeight="5" orient="auto-start-reverse"><path d="M1 1.5L8.5 5L1 8.5" fill="none" stroke="context-stroke" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></marker></defs>';
    h+='<polygon points="'+sp.map(s).join(' ')+'" fill="'+fillC+'" stroke="'+strokeC+'" stroke-width="1.6" stroke-linejoin="round"/>';
    function edge(i,j,color,w){h+='<line x1="'+f(sp[i][0])+'" y1="'+f(sp[i][1])+'" x2="'+f(sp[j][0])+'" y2="'+f(sp[j][1])+'" stroke="'+color+'" stroke-width="'+w+'" stroke-linecap="round"/>';}
    edge(1,2,GREEN,3.4);edge(5,0,GREEN,3.4);edge(2,3,BLUE,3);edge(4,5,BLUE,3);
    if(state.piping==='single'||state.piping==='double'){h+='<polygon points="'+sp.map(s).join(' ')+'" fill="none" stroke="#F5F1E8" stroke-width="1.6" stroke-linejoin="round" opacity="0.8"/>';}
    // A top edge
    var cA=col(state.te,DIMC);var a1=[sp[0][0],sp[0][1]-14],a2=[sp[1][0],sp[1][1]-14];
    h+='<line x1="'+f(sp[0][0])+'" y1="'+f(sp[0][1])+'" x2="'+f(a1[0])+'" y2="'+f(a1[1])+'" stroke="'+cA+'" stroke-width="0.5"/><line x1="'+f(sp[1][0])+'" y1="'+f(sp[1][1])+'" x2="'+f(a2[0])+'" y2="'+f(a2[1])+'" stroke="'+cA+'" stroke-width="0.5"/>';
    arrowLine(a1,a2,cA);lbl((a1[0]+a2[0])/2,a1[1]-7,tag('A',state.te),cA);
    // B widest width (inside the shape)
    var cB=col(state.mw,DIMC);arrowLine(sp[5],sp[2],cB);lbl((sp[5][0]+sp[2][0])/2,sp[5][1]-7,tag('B',state.mw),cB);
    // C bottom edge
    var cC=col(state.be,DIMC);var c1=[sp[4][0],sp[4][1]+14],c2=[sp[3][0],sp[3][1]+14];
    h+='<line x1="'+f(sp[4][0])+'" y1="'+f(sp[4][1])+'" x2="'+f(c1[0])+'" y2="'+f(c1[1])+'" stroke="'+cC+'" stroke-width="0.5"/><line x1="'+f(sp[3][0])+'" y1="'+f(sp[3][1])+'" x2="'+f(c2[0])+'" y2="'+f(c2[1])+'" stroke="'+cC+'" stroke-width="0.5"/>';
    arrowLine(c1,c2,cC);lbl((c1[0]+c2[0])/2,c1[1]+19,tag('C',state.be),cC);
    // D top height, E bottom height (right side)
    var rx=sp[2][0]+14;var cD=col(state.th,DIMC),cE=col(state.bh,DIMC);
    arrowLine([rx,sp[1][1]],[rx,sp[2][1]],cD);lbl(rx+6,(sp[1][1]+sp[2][1])/2+5,tag('D',state.th),cD,'start');
    arrowLine([rx,sp[2][1]],[rx,sp[3][1]],cE);lbl(rx+6,(sp[2][1]+sp[3][1])/2+5,tag('E',state.bh),cE,'start');
    // computed slant lengths (left side), only once their inputs are in
    if(state.te&&state.mw&&state.th)lbl((sp[5][0]+sp[0][0])/2-10,(sp[5][1]+sp[0][1])/2,upperDiag(te,mw,th).toFixed(1)+'″',GREEN,'end',12);
    if(state.be&&state.mw&&state.bh)lbl((sp[4][0]+sp[5][0])/2-10,(sp[4][1]+sp[5][1])/2+8,lowerDiag(be,mw,bh).toFixed(1)+'″',BLUE,'end',12);
    svg.innerHTML=h;
  }

  function updateSummary(){
    if(!els.summary)return;var parts=[];
    if(dimsValid())parts.push('Diamond '+state.te+'/'+state.mw+'/'+state.be+' × '+state.t+'″');
    if(state.fabric)parts.push(state.fabric.title);
    if(state.piping&&state.piping!=='none')parts.push(LABELS[state.piping]);
    if(state.straps&&state.straps!=='none')parts.push(LABELS[state.straps]);
    if(state.antislip&&state.antislip!=='none')parts.push(LABELS[state.antislip]);
    els.summary.textContent=parts.length?parts.join(' · '):'Configure your diamond cushion below';
  }

  function recalc(){
    var _cf=window.__ucfs_selectedFabric||window._ucfsSelected;if(_cf&&_cf!==state.fabric)state.fabric=_cf;
    state.te=parseFloat(els.inTe.value)||0;
    state.mw=parseFloat(els.inMw.value)||0;
    state.t =parseFloat(els.inT.value)||0;
    state.be=els.inBe?(parseFloat(els.inBe.value)||0):0;
    state.th=els.inTh?(parseFloat(els.inTh.value)||0):0;
    state.bh=els.inBh?(parseFloat(els.inBh.value)||0):0;
    state.extraCovers=els.extraCovers.value;
    state.throwPillow=els.throwPillow?els.throwPillow.value:'none';
    state.pillowCovers=els.pillowCovers?els.pillowCovers.value:'none';
    state.armrestPillow=els.armrestPillow?els.armrestPillow.value:'none';
    state.zipperPlacement=els.zipperPlacement?els.zipperPlacement.value:'';
    state.pipingColor=els.pipingColor?els.pipingColor.value:'match';
    state.notes=els.notes.value;
    if(els.pipingColorWrap){var show=(state.piping==='single'||state.piping==='double');els.pipingColorWrap.style.display=show?'':'none';if(!show){state.pipingColor='match';if(els.pipingColor)els.pipingColor.value='match';}}
    [['inTe',state.te],['inMw',state.mw],['inBe',state.be],['inTh',state.th],['inBh',state.bh],['inT',state.t]].forEach(function(p){if(els[p[0]])els[p[0]].classList.toggle('ok',p[1]>0);});
    drawCushion();updateSummary();
    var ec=parseInt(state.extraCovers)||0;
    updateExtraCoverLabels();
    var v=dimsValid()?vertices(state.te,state.mw,state.be,state.th,state.bh):null;
    var base=v?calcBasePrice(v,state.t,ec,state.throwPillow):null;
    var addonTotal=getAddonTotal();
    if(base!==null){
      els.priceMain.textContent='$'+Math.round(base+addonTotal);
      var parts=['Base $'+Math.round(base)];
      if(ADDON.piping[state.piping])parts.push('Piping +$'+ADDON.piping[state.piping]);
      if(ADDON.pipingColor[state.pipingColor])parts.push('Piping color +$'+ADDON.pipingColor[state.pipingColor]);
      if(ADDON.straps[state.straps])parts.push('Straps +$'+ADDON.straps[state.straps]);
      if(ADDON.zipper[state.zipper])parts.push('Zipper +$'+ADDON.zipper[state.zipper]);
      if(ADDON.antislip[state.antislip])parts.push('Anti-slip +$'+ADDON.antislip[state.antislip]);
      if(ec>0)parts.push('Covers +$'+(extraCoverUnit()*ec));
      if(ADDON.throwPillow[state.throwPillow])parts.push('Pillow +$'+ADDON.throwPillow[state.throwPillow]);
      if(ADDON.pillowCovers[state.pillowCovers])parts.push('P.Covers +$'+ADDON.pillowCovers[state.pillowCovers]);
      if(ADDON.armrestPillow[state.armrestPillow])parts.push('Armrest +$'+ADDON.armrestPillow[state.armrestPillow]);
      els.priceBreak.textContent=parts.join(' · ');
    } else { els.priceMain.textContent='$—';els.priceBreak.textContent='Enter dimensions to see price'; }
    var complete=isComplete();
    [els.addBtn,els.addBtnSticky].filter(Boolean).forEach(function(btn){btn.disabled=!complete;btn.textContent=(complete&&base!==null)?('Add to order — $'+Math.round(base+addonTotal)+' · Free shipping →'):'Add to order →';});
    if(els.addNote){if(complete){els.addNote.textContent='Free shipping · Ships in ~20 business days';}else{var m=[];if(!dimsValid())m.push('all dimensions');if(!state.fabric)m.push('fabric');if(!state.piping)m.push('piping');if(!state.straps)m.push('straps');if(!state.antislip)m.push('anti-slip');els.addNote.textContent=m.length?'Select '+m.join(', ')+' to continue':'';}}
    document.dispatchEvent(new CustomEvent('configurator:price-updated',{detail:{price:base!==null?Math.round(base+addonTotal):null,state:state}}));
  }

  function pickCard(el,group,value){el.parentElement.querySelectorAll('.cc-opt-card').forEach(function(c){c.classList.remove('sel');});el.classList.add('sel');state[group]=value;recalc();}

  function getLineProperties(){
    var ec=parseInt(state.extraCovers)||0;
    var v=vertices(state.te,state.mw,state.be,state.th,state.bh);
    var base=calcBasePrice(v,state.t,ec,state.throwPillow);
    var finalPrice=Math.round(base+getAddonTotal());
    var props={
      'Shape':'Diamond (hexagon)',
      'Top edge':state.te+'"','Max width':state.mw+'"','Bottom edge':state.be+'"',
      'Top height':state.th+'"','Bottom height':state.bh+'"','Thickness':state.t+'"',
      'Upper diagonal':upperDiag(state.te,state.mw,state.th).toFixed(1)+'" (zipper edge)',
      'Lower diagonal':lowerDiag(state.be,state.mw,state.bh).toFixed(1)+'"',
      'Piping':LABELS[state.piping]||state.piping,
      'Piping Color':(state.pipingColor&&state.pipingColor!=='match')?(LABELS[state.pipingColor]||state.pipingColor):'Match fabric',
      'Straps':LABELS[state.straps]||state.straps,'Zipper':LABELS[state.zipper]||state.zipper,'Anti-slip':LABELS[state.antislip]||state.antislip
    };
    if(state.zipperPlacement){props['Zipper Placement']= state.zipperPlacement;}
    if(state.fabric){props['Fabric']=state.fabric.title||'';props['_Fabric SKU']=(state.fabric.variants&&state.fabric.variants[0]&&state.fabric.variants[0].sku)||'';props['_Fabric Handle']=state.fabric.handle||'';props['_Fabric Image']=(state.fabric.images&&state.fabric.images[0]&&state.fabric.images[0].src)||'';var _g=extractTag(state.fabric.tags||[],'grade');if(_g)props['Fabric Grade']=_g.charAt(0).toUpperCase()+_g.slice(1);}
    if(ec>0)props['Extra Covers']=ec+' set(s) (+$'+(extraCoverUnit()*ec)+')';
    if(state.throwPillow&&state.throwPillow!=='none')props['Throw Pillow']=state.throwPillow.replace(/_/g,' ')+' (+$'+ADDON.throwPillow[state.throwPillow]+')';
    if(state.pillowCovers&&state.pillowCovers!=='none')props['Pillow Covers']=state.pillowCovers.replace(/_/g,' ')+' (+$'+ADDON.pillowCovers[state.pillowCovers]+')';
    if(state.armrestPillow&&state.armrestPillow!=='none')props['Armrest Pillow']=state.armrestPillow.replace(/_/g,' ')+' (+$'+ADDON.armrestPillow[state.armrestPillow]+')';
    if(state.notes.trim())props['Customer Note']=state.notes.trim();
    props['_Source Product']=(document.getElementById('cc-configurator')||{dataset:{}}).dataset.productTitle||document.title;
    return {properties:props,price:finalPrice};
  }

  function transformDOM(){
    var shapeSection=document.getElementById('cc-shape-section');if(shapeSection)shapeSection.style.display='none';
    var lL=document.querySelector('label[for="cc-dim-l"]');if(lL)lL.innerHTML='A — Top edge (in) <span class="cc-req">*</span>';
    var iL=document.getElementById('cc-dim-l');if(iL){iL.placeholder='e.g. 45';iL.min='4';iL.max='220';}
    var lW=document.querySelector('label[for="cc-dim-w"]');if(lW)lW.innerHTML='B — Max width (in) <span class="cc-req">*</span>';
    var iW=document.getElementById('cc-dim-w');if(iW){iW.placeholder='e.g. 70';iW.min='6';iW.max='240';}
    var lT=document.querySelector('label[for="cc-dim-t"]');if(lT)lT.innerHTML='Thickness (in) <span class="cc-req">*</span>';
    var backRows=document.querySelectorAll('.cc-back-dims');for(var i=0;i<backRows.length;i++){var el=backRows[i];el.style.display=el.classList.contains('cc-sp-dims')?'grid':'block';}
    var backLabel=document.querySelector('.cc-back-label');if(backLabel)backLabel.textContent='Bottom & heights';
    var lBL=document.querySelector('label[for="cc-back-l"]');if(lBL)lBL.innerHTML='C — Bottom edge (in) <span class="cc-req">*</span>';
    var iBL=document.getElementById('cc-back-l');if(iBL){iBL.placeholder='e.g. 10';iBL.min='2';iBL.max='220';}
    var lBW=document.querySelector('label[for="cc-back-w"]');if(lBW)lBW.innerHTML='D — Top height (in) <span class="cc-req">*</span>';
    var iBW=document.getElementById('cc-back-w');if(iBW){iBW.placeholder='e.g. 15';iBW.min='2';iBW.max='140';}
    var lBT=document.querySelector('label[for="cc-back-t"]');if(lBT)lBT.innerHTML='E — Bottom height (in) <span class="cc-req">*</span>';
    var iBT=document.getElementById('cc-back-t');if(iBT){iBT.placeholder='e.g. 31';iBT.min='2';iBT.max='160';}
    var hint=document.querySelector('.cc-sp-hint');if(hint)hint.textContent='Top / widest / bottom widths + the two heights. Slant edges auto-calculated. Zipper on the two upper (green) edges.';
    var sns=document.querySelectorAll('.cc-sec-head .cc-sn');var n=1;for(var k=0;k<sns.length;k++){var sec=sns[k].closest('.cc-sec');if(sec&&sec.style.display!=='none'&&sns[k].textContent.trim()!=='i')sns[k].textContent=n++;}
  }

  function init(){
    var wrap=document.getElementById('cc-configurator');if(!wrap)return;
    if((wrap.dataset.formulaType||'')!=='diamond')return;
    transformDOM();
    els.priceMain=document.getElementById('cc-price-main');els.priceBreak=document.getElementById('cc-price-break');els.summary=document.getElementById('cc-sp-summary');
    els.inTe=document.getElementById('cc-dim-l');els.inMw=document.getElementById('cc-dim-w');els.inT=document.getElementById('cc-dim-t');
    els.inBe=document.getElementById('cc-back-l');els.inTh=document.getElementById('cc-back-w');els.inBh=document.getElementById('cc-back-t');
    els.extraCovers=document.getElementById('cc-extra-covers');els.throwPillow=document.getElementById('cc-throw-pillow');els.pillowCovers=document.getElementById('cc-pillow-covers');els.armrestPillow=document.getElementById('cc-armrest-pillow');
    els.zipperPlacement=document.getElementById('cc-zipper-placement');els.pipingColor=document.getElementById('cc-piping-color');els.pipingColorWrap=document.getElementById('cc-piping-color-wrap');
    els.notes=document.getElementById('cc-notes');els.addBtn=document.getElementById('cc-add-btn');els.addBtnSticky=document.getElementById('cc-add-btn-sticky');els.addNote=document.getElementById('cc-add-note');els.dimSvg=document.getElementById('cc-dim-svg');
    wrap.addEventListener('click',function(e){var card=e.target.closest('.cc-opt-card');if(!card||!card.dataset.group)return;pickCard(card,card.dataset.group,card.dataset.value);});
    ['inTe','inMw','inT','inBe','inTh','inBh'].forEach(function(id){if(els[id])els[id].addEventListener('input',recalc);});
    els.extraCovers.addEventListener('change',recalc);
    if(els.throwPillow)els.throwPillow.addEventListener('change',recalc);
    if(els.pillowCovers)els.pillowCovers.addEventListener('change',recalc);
    if(els.armrestPillow)els.armrestPillow.addEventListener('change',recalc);
    if(els.zipperPlacement)els.zipperPlacement.addEventListener('change',recalc);
    if(els.pipingColor)els.pipingColor.addEventListener('change',recalc);
    els.notes.addEventListener('input',recalc);
    document.addEventListener('fabric:selected',function(e){state.fabric=e.detail;recalc();});
    var ef=window.__ucfs_selectedFabric||window._ucfsSelected;if(!state.fabric&&ef){state.fabric=ef;}
    setInterval(function(){var fb=window.__ucfs_selectedFabric||window._ucfsSelected;if(fb&&fb!==state.fabric){state.fabric=fb;recalc();}},800);
    function handleAdd(){if(!isComplete())return;document.dispatchEvent(new CustomEvent('configurator:add-to-cart',{detail:getLineProperties()}));}
    if(els.addBtn)els.addBtn.addEventListener('click',handleAdd);if(els.addBtnSticky)els.addBtnSticky.addEventListener('click',handleAdd);
    var dz=wrap.querySelector('.cc-opt-card[data-group="zipper"][data-value="regular"]');if(dz)dz.classList.add('sel');
    drawCushion();recalc();
  }

  window.DiamondCushionConfigurator={getState:function(){return state;},getLineProperties:getLineProperties,recalc:recalc};
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}
})();